import { render } from "./CourseExerciseSolutionThreads.vue?vue&type=template&id=0b3dca18&ts=true"
import script from "./CourseExerciseSolutionThreads.vue?vue&type=script&lang=ts"
export * from "./CourseExerciseSolutionThreads.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__